import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@common/utils/api';
import _ from 'lodash';
import ProductTilesRail from '../product/ProductTilesRail';
import ShopByCollection from '../shopByCollection/ShopByCollection';
const SearchNoResults = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const [pageData, setPageData] = useState(null);
    useEffect(() => {
        if (!pageData) {
            api.getPageJson('search-noresults', true).then((data) => {
                if (data) {
                    setPageData(data);
                }
            });
        }
    }, []);
    // ANCHOR - USE MEMO --------------------------------------------------------------------
    const suggestionRegion = useMemo(() => {
        var _a, _b, _c;
        const suggestions = _.filter(pageData === null || pageData === void 0 ? void 0 : pageData.regions, (el) => el.id === 'suggestions');
        if ((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) && ((_b = (_a = suggestions[0]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.length)) {
            // debugger;
            return (_c = suggestions[0]) === null || _c === void 0 ? void 0 : _c.components[0];
        }
        return;
    }, [pageData]);
    const suggestions = useMemo(() => { var _a; return (_a = suggestionRegion === null || suggestionRegion === void 0 ? void 0 : suggestionRegion.regions[0]) === null || _a === void 0 ? void 0 : _a.components; }, [suggestionRegion]);
    const carouselRegion = useMemo(() => {
        var _a, _b, _c;
        const carousels = _.filter(pageData === null || pageData === void 0 ? void 0 : pageData.regions, (el) => el.id === 'carousel');
        if ((carousels === null || carousels === void 0 ? void 0 : carousels.length) && ((_b = (_a = carousels[0]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.length)) {
            return (_c = carousels[0]) === null || _c === void 0 ? void 0 : _c.components[0];
        }
        return;
    }, [pageData]);
    const shopByCollectionRegion = useMemo(() => {
        var _a, _b, _c;
        const shopbycollection = _.filter(pageData === null || pageData === void 0 ? void 0 : pageData.regions, (el) => el.id === 'shopbycollection');
        if ((shopbycollection === null || shopbycollection === void 0 ? void 0 : shopbycollection.length) && ((_b = (_a = shopbycollection[0]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.length)) {
            return (_c = shopbycollection[0]) === null || _c === void 0 ? void 0 : _c.components[0];
        }
        return;
    }, [pageData]);
    const shopByCollection = useMemo(() => {
        var _a, _b;
        return (_b = (_a = shopByCollectionRegion === null || shopByCollectionRegion === void 0 ? void 0 : shopByCollectionRegion.regions[0]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.map((c) => {
            return Object.assign(Object.assign({}, c.data), c.custom);
        });
    }, [shopByCollectionRegion]);
    // SECTION - RENDER --------------------------------------------------------------------
    return (React.createElement("div", { className: "no-results-container" },
        React.createElement("div", { className: "no-results-content" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-24" },
                        React.createElement("div", { className: "no-results__title--wrapper" },
                            React.createElement("h2", { className: "search-page-header--title" }, props.resultsNumber))),
                    React.createElement("div", { className: "col-lg-24" }, React.createElement("div", { className: "no-results__description", dangerouslySetInnerHTML: { __html: ((_a = pageData === null || pageData === void 0 ? void 0 : pageData.data) === null || _a === void 0 ? void 0 : _a.rich_text) || t('search.noresults.description') } }))))),
        carouselRegion && (React.createElement("div", { className: "no-results-carousel" },
            React.createElement(ProductTilesRail, Object.assign({}, carouselRegion.data)))),
        shopByCollection && React.createElement(ShopByCollection, { title: (_b = shopByCollectionRegion === null || shopByCollectionRegion === void 0 ? void 0 : shopByCollectionRegion.data) === null || _b === void 0 ? void 0 : _b.title, collections: shopByCollection })));
    // !SECTION END RENDER
};
export default SearchNoResults;
